export type BillingPlanKey = string;

export type PricingPlanDefinition = {
  key: BillingPlanKey;
  name: string;
  unitPrice: number;
  priceLabel: string;
  badge?: string;
  description: string;
  features: string[];
  highlight?: boolean;
  salesOnly?: boolean;
};

export type PricingPlanQuantities = Record<string, number>;

export const FALLBACK_FORGE_PRICING_PLANS: PricingPlanDefinition[] = [
  {
    key: 'starter',
    name: 'Forge Starter',
    unitPrice: 39,
    priceLabel: '39€ / user / month',
    description: 'For teams that want faster scenario generation and cleaner iteration loops.',
    features: ['Challenge Requirements', 'Scenario generation', 'Scenario improvement', 'Named seat allocation']
  },
  {
    key: 'builder',
    name: 'Forge Builder',
    unitPrice: 69,
    priceLabel: '69€ / user / month',
    badge: 'Recommended',
    description: 'Adds implementation workspace workflows for delivery and automation teams.',
    features: ['Challenge Requirements', 'Everything in Starter', 'Implementation workspace', 'Operational delivery support'],
    highlight: true
  },
  {
    key: 'guardian',
    name: 'Forge Guardian',
    unitPrice: 129,
    priceLabel: '129€ / user / month',
    description: 'Adds audit and QA governance for organizations that need explainable control.',
    features: ['Challenge Requirements', 'Everything in Builder', 'Audit feature', 'QA governance visibility']
  },
  {
    key: 'agentic',
    name: 'Forge CI/CD',
    unitPrice: 0,
    priceLabel: 'Custom pricing',
    badge: 'Premium',
    description: 'Merge request QA analysis and assisted testing actions before merge.',
    features: ['Challenge Requirements', 'Everything in Guardian', 'CI/CD review workflows'],
    highlight: true,
    salesOnly: true
  }
];
